<template>
    <div class="row">
        <div class="col-6">
            <div class="card with-padding with-shadow details">
                <ul>
                    <li><span class="key">Your Name: </span><span class="value">{{ profile.fullName }}</span></li>
                    <li><span class="key">Mobile Phone: </span><span class="value">{{ profile.mobile }}</span></li>
                    <li><span class="key">Home Address: </span><span class="value">{{ profile.homeAddress }}</span></li>
                    <li><span class="key">Postcode: </span><span class="value">{{ profile.postcode }}</span></li>
                </ul>
            </div>
        </div>
        <div class="col-4">
            <div class="card with-padding with-shadow annual-mileage"
                 :style="'--width:' + mileagePercent + '%'">
                <h3>Annual Mileage
                    <VDropdown :disabled="!tooltip">
                        <button class="tooltip-button"><i class="icon-info-solid"/></button>
                        <template #popper>
                            <p>This is the mileage you provided during the invite process.</p>
                        </template>
                    </VDropdown>
                </h3>
                <ul>
                    <li class="private"><span class="key">Business</span><span
                        class="value">{{ Number(profile.businessAnnualMileage) }}</span>
                    </li>
                    <li class="business"><span class="key">Private</span><span
                        class="value">{{ Number(profile.privateAnnualMileage) }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-2">
            <div class="card with-padding with-shadow tax-band">
                <h3>
                    Tax Band
                    <VDropdown :disabled="!tooltip">
                        <button class="tooltip-button"><i class="icon-info-solid"/></button>
                        <template #popper>
                            <p>{{ taxBandTooltip }}</p>
                        </template>
                    </VDropdown>
                </h3>
                <ul>
                    <li><span class="value">{{ profile.incomeTaxBand }}%</span></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ecoamaps-your-details-component',

    props: [
        'mileagePercent',
        'profile',
        'tooltip',
        'taxBandTooltip',
    ],
}
</script>

<style lang="scss" scoped>
.annual-mileage {
    &:before {
        content: '';
        position: absolute;
        top: calc(100% - 10px);
        left: 0;
        height: 10px;
        width: var(--width);
        background-color: #2e9da0;
        border-bottom-left-radius: 5px;
        z-index: 2;
    }
}
</style>
